import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks';
import { LoadingFallback } from '@/components/layout/LoadingFallback';

/*
 * ProtectedRoute (Sessio 5b).
 *
 * React Router 7 -pattern: kayttaa Outlet:ia + sisaisia route:ja. router.tsx
 * paaltaa moduulireitit (/, /ideoi, /suunnittele, ...) tama wrapperin alaisuuteen.
 *
 * Kayttaytyminen tilan mukaan (useAuth().status):
 *  - 'loading'         -> LoadingFallback (estetaan vilkahdus /login:iin
 *                         sivulatauksen / F5:n yhteydessa)
 *  - 'authenticated'   -> renderoi Outlet (alemmat reitit)
 *  - 'unauthenticated' -> Navigate /login:iin replace=true, talleta from-state
 *                         jotta login-sivu osaa palata kayttajan alkuperaiseen URLiin
 */
export function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return <LoadingFallback />;
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
